import { render, staticRenderFns } from "./newadd.vue?vue&type=template&id=01512cc0&scoped=true&"
import script from "./newadd.vue?vue&type=script&lang=js&"
export * from "./newadd.vue?vue&type=script&lang=js&"
import style1 from "@/assets/css/dialogbox.less?vue&type=style&index=1&id=01512cc0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01512cc0",
  null
  
)

export default component.exports